'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/seo.ts
var SEO_QUERY = `
title
description
keywords
image {${IMAGE_QUERY}}
noindex
`;

export {
  SEO_QUERY
};
//# sourceMappingURL=chunk-W3K3QG4J.mjs.map